// ─────────────────────────────────────────────────────────────────────────────
// INSTRUMENT REGISTRY
//
// To add a new instrument:
//   1. Create src/instruments/<name>/index.js exporting the contract
//   2. Import it here and add one line to INSTRUMENTS
//   3. Done — the entire platform works with it automatically
// ─────────────────────────────────────────────────────────────────────────────
import ASSESS  from "./assess/index.js";
import BIG_FIVE from "./bigfive/index.js";
import EQ       from "./eq/index.js";
import BELBIN   from "./belbin/index.js";
import IQ       from "./iq/index.js";
import SL       from "./sl/index.js";
import LA       from "./la/index.js";
import CAB           from "./cab/index.js";
import NUMERICAL      from "./numerical/index.js";
import CRITICAL_THINKING from "./critical_thinking/index.js";
import DISC    from "./disc/index.js";
import SALESAXIS from "./salesaxis/index.js";
import VERBAL         from "./verbal/index.js";
import ABSTRACT      from "./abstract/index.js";
import ATTENTION     from "./attention/index.js";
import MECHANICAL    from "./mechanical/index.js";
import DIAGRAMMATIC   from "./diagrammatic/index.js";
import SJT_CUSTOMER    from "./sjt_customer/index.js";
import SJT_MANAGEMENT  from "./sjt_management/index.js";
import SJT_SALES       from "./sjt_sales/index.js";
import RIASEC          from "./riasec/index.js";
import BehavioralFit    from "./behavioral_fit/index.js";
import WORK_STYLE      from "./work_style/index.js";
import RESILIENCE      from "./resilience/index.js";
import INTEGRITY       from "./integrity/index.js";
import FTM             from "./ftm/index.js";
import LD              from "./ld/index.js";
import RESales         from "./re_sales/index.js";
import SalesAxisRE     from "./salesaxis_re/index.js";

// Registry — keyed by instrument id
const INSTRUMENTS = {
  assess:  ASSESS,
  bigfive: BIG_FIVE,
  eq:      EQ,
  belbin:  BELBIN,
  iq:      IQ,
  sl:      SL,
  la:      LA,
  cab:     CAB,       // Cognitive Ability Battery — Express tier
  salesaxis: SALESAXIS,
  critical_thinking: CRITICAL_THINKING,
  numerical: NUMERICAL, // Standalone Numerical Reasoning — volume tier
  verbal:       VERBAL,       // Standalone Verbal Reasoning
  abstract:     ABSTRACT,     // Standalone Abstract Reasoning
  attention:    ATTENTION,    // Standalone Attention to Detail
  mechanical:   MECHANICAL,   // Standalone Mechanical Reasoning
  diagrammatic:   DIAGRAMMATIC,  // Standalone Diagrammatic Reasoning
  sjt_customer:   SJT_CUSTOMER,   // Customer Service SJT — volume tier
  sjt_management: SJT_MANAGEMENT, // Management SJT — internal promotions
  sjt_sales:      SJT_SALES,      // Sales SJT — BFSI, Pharma, FMCG volume
  work_style:     WORK_STYLE,     // Work Style Screener — frontline volume hiring
  resilience:     RESILIENCE,     // Resilience Screener — high-pressure role hiring
  integrity:      INTEGRITY,      // Integrity Screener — trust-critical role hiring
  ftm:            FTM,            // First-Time Manager Transition Assessment
  ld:             LD,             // Leadership Derailers Assessment
  re_sales:       RESales,        // Real Estate Sales Readiness Screener
  riasec:         RIASEC,         // Career Interest Profile
  behavioral_fit: BehavioralFit,  // Pre-Employment Assess BeFit Screener
  salesaxis_re:   SalesAxisRE,    // SalesAxis 2.0 — Real Estate Edition


  // Coming soon — each follows the same contract:
  // la added above
  disc: DISC,
  // via:     VIA,
  // holland: HOLLAND,
  // hogan:   HOGAN,     // partner API wrapper
};

// ── Public API ────────────────────────────────────────────────────────────────
export const getInstrument    = id  => INSTRUMENTS[id] || null;
export const allInstruments   = ()  => Object.values(INSTRUMENTS);
export const instrumentIds    = ()  => Object.keys(INSTRUMENTS);
export const isValidInstrument= id  => id in INSTRUMENTS;

export default INSTRUMENTS;
